<!--
 * @Descripttion: 系统内置穿梭狂组件 V0.1.1 改版, 基于dataTable V0.1.1。
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-07-03 09:57:58
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-27 13:49:14
 -->
<template>
  <div id="transfer " v-if="transferInfo">
      <!-- start::穿梭弹出框 -->
      <el-dialog v-loading="sloading" class="avue-dialog no-el-dialog__body__padding" v-if="transferInfo.setting"  fullscreen :append-to-body="true" :visible.sync='transferInfo.setting.show' :title="transferInfo.setting.title||'请为你的穿梭框定义标题'" >
          <el-row :gutter="20">
              <!-- 穿梭框数据表一 -->
              <el-col :span="11">
                  <easyCrud ref="dataSourceOne"
                  :tableInfo='transferInfo.dataSourceOne'
                  @loadDataSourceOne ="loadDataSourceOne" ></easyCrud>
              </el-col>
              <!-- 穿梭框 炒作区域 -->
              <el-col :span="2" >
                  <div class="el-transfer__buttons" style="margin-top:300%;">
                      <button v-loading="transferInfo.dataSourceTwo.table.loading || transferInfo.dataSourceOne.table.loading" @click="transfer('toLeft')" type="button" class="el-button el-button--primary  el-transfer__button" >
                          <span>
                          <i class="el-icon-arrow-left"></i>
                          </span>
                      </button>
                      <button v-loading="transferInfo.dataSourceTwo.table.loading || transferInfo.dataSourceOne.table.loading" @click="transfer('toRight')" type="button" class="el-button el-button--primary  el-transfer__button">
                          <span>
                          <i class="el-icon-arrow-right"></i>
                          </span>
                      </button>
                  </div>
              </el-col>
              <!-- 穿梭框数据表二 -->
              <el-col :span="11">
                  <easyCrud  ref="dataSourceTwo"
                  :tableInfo='transferInfo.dataSourceTwo'
                  @loadDataSourceTwo ="loadDataSourceTwo"
                    ></easyCrud>
              </el-col>
          </el-row>
          <!-- 穿梭狂取消按钮 -->
          <el-row :gutter="20">
              <el-col :span="2" :offset="11">
                  <el-button  style="margin-top:10px;margin-left:10px;" @click="transferInfo.setting.show = false">返 回</el-button>
              </el-col>
          </el-row >
      </el-dialog>
      <!-- end::穿梭弹出框 -->
  </div>
</template>

<script>

import easyCrud from '@/framework/components/baseComponent/easyCrud/easyCrud.vue'
import mixLoading from '@/framework/mixins/loading.js'

export default {
  components: { easyCrud },
  props: ['transferInfo'],
  mixins: [mixLoading],
  data() {
    return {

    }
  },
  methods: {
    /** 中转数据表一 reload 到父组件 */
    loadDataSourceOne: function(params) {
      this.$emit('loadDataSourceOne', params)
    },
    /** 中转数据表二 reload 到父组件 */
    loadDataSourceTwo: function(params) {
      this.$emit('loadDataSourceTwo', params)
    },
    /** */
    transfer: function(option) {
      /** 像左移动 */
      this.sloading = true
      const that = this
      if (option === 'toLeft') {
        const selectedData = this.$refs.dataSourceTwo.getSelectedRows()
        if (!selectedData || selectedData.length === 0) {
          this.$message.error('您必须选中至少一条数据后,才能进行此操作。')
          return
        }
        this.transferInfo.dataSourceTwo.table.loading = true
        this.transferInfo.dataSourceOne.table.loading = true
        this.$emit(this.transferInfo.setting.toLeftTransfer, selectedData, this, function(base) {
          base.transferInfo.dataSourceTwo.table.loading = false
          base.transferInfo.dataSourceOne.table.loading = false
          /** 修改页总数 */
          base.transferInfo.dataSourceOne.table.paging.total = base.transferInfo.dataSourceOne.table.paging.total + selectedData.length
          base.transferInfo.dataSourceTwo.table.paging.total = base.transferInfo.dataSourceTwo.table.paging.total - selectedData.length
          /** 加入到对面数组 */
          for (let index = 0; index < selectedData.length; index++) {
            base.transferInfo.dataSourceOne.table.tableData.push(selectedData[index])
          }
          /** 从自己数组剔除 */
          var keyName = base.transferInfo.setting.keyName || 'id'
          for (let index = 0; index < selectedData.length; index++) {
            for (let j = 0; j < base.transferInfo.dataSourceTwo.table.tableData.length; j++) {
              if (base.transferInfo.dataSourceTwo.table.tableData[j][keyName] === selectedData[index][keyName]) {
                base.transferInfo.dataSourceTwo.table.tableData.splice(j, 1)
              }
            }
          }
          base.handNoData('toLeft')
          that.sloading = false
        })
        /** 向右移动 */
      } else {
        const selectedData = this.$refs.dataSourceOne.getSelectedRows()
        if (!selectedData || selectedData.length === 0) {
          this.$message.error('您必须选中至少一条数据后,才能进行此操作。')
          return
        }
        this.transferInfo.dataSourceTwo.table.loading = true
        this.transferInfo.dataSourceOne.table.loading = true
        this.$emit(this.transferInfo.setting.toRightTransfer, selectedData, this, function(base) {
          base.transferInfo.dataSourceTwo.table.loading = false
          base.transferInfo.dataSourceOne.table.loading = false
          /** 先修改页总数 */
          base.transferInfo.dataSourceTwo.table.paging.total = base.transferInfo.dataSourceTwo.table.paging.total + selectedData.length
          base.transferInfo.dataSourceOne.table.paging.total = base.transferInfo.dataSourceOne.table.paging.total - selectedData.length
          /** 加入到对面数组 */
          for (let index = 0; index < selectedData.length; index++) {
            base.transferInfo.dataSourceTwo.table.tableData.push(selectedData[index])
          }
          /** 从自己数组剔除 */
          var keyName = base.transferInfo.setting.keyName || 'id'
          for (let index = 0; index < selectedData.length; index++) {
            for (let j = 0; j < base.transferInfo.dataSourceOne.table.tableData.length; j++) {
              if (base.transferInfo.dataSourceOne.table.tableData[j][keyName] === selectedData[index][keyName]) {
                base.transferInfo.dataSourceOne.table.tableData.splice(j, 1)
              }
            }
          }
          base.handNoData('toRight')
          that.sloading = false
        })
      }
    },
    /**
   * 220/05/27 穿梭后可能存在没有数据的情况，这时候判断是否存在分页，存在则前进一页
   */
    handNoData(movingDirection) {
      debugger
      let dataSource = movingDirection === 'toLeft' ? this.transferInfo.dataSourceTwo.table : this.transferInfo.dataSourceOne.table
      let refTag = movingDirection === 'toLeft' ? 'dataSourceTwo' : 'dataSourceOne'
      if (dataSource.tableData.length <= 0 && dataSource.paging && dataSource.paging.currentPage) {
        // 没有数据了，且有分页
        if (dataSource.paging.currentPage > 1) {
          dataSource.paging.currentPage--
        }
        this.$refs[refTag].reload()
      }
    }
  }

}
</script>
 <style lang='css' scoped>
 </style>
